<template>
    <ion-page class="ion-page" id="main">
        <default-header>
            <template v-slot:start>
                <ion-buttons slot="start">
                    <router-link :to="{ name: 'contacts'}">
                        <ion-button>
                            <ion-icon md="arrow-back" ios="arrow-back" slot="start"/>

                            {{ $t('ncrypt.menu.item_contacts') }}
                        </ion-button>
                    </router-link>
                </ion-buttons>
            </template>

            <template>
                <span></span>
            </template>
        </default-header>

        <ion-content fullscreen>
            <flash-messages/>
            <ion-grid>
                <ion-row>
                    <ion-col>
                        <contact :contact="contact"/>
                    </ion-col>

                    <ion-col>
                        <ion-card>
                            <ion-card-header>
                                <ion-card-title>
                                    {{ $t('ncrypt.contacts.detail_communication_title') }}
                                </ion-card-title>
                            </ion-card-header>

                            <ion-card-content>
                                <ion-list>
                                    <contact-communication-message
                                        v-for="(message, i) in communications"
                                        :key="`${i}-${message.id}`"
                                        :message="message"
                                    />
                                </ion-list>
                            </ion-card-content>
                        </ion-card>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-content>
    </ion-page>
</template>

<script>
    import Contact from "../../components/contacts/Contact";
    import FlashMessages from "../../components/ui-elements/FlashMessages";
    import {ApiError} from "../../errors/ApiError";
    import ContactCommunicationMessage from "../../components/contacts/ContactCommunicationMessage";
    import DefaultHeader from "../../components/nav/DefaultHeader";

    export default {
        components: {DefaultHeader, ContactCommunicationMessage, FlashMessages, Contact},
        data() {
            return {
                contact: {},
                communications: [],
            }
        },
        methods: {
            async retrieveContact() {
                const loader = await this.$ionic.loadingController.create({
                    duration: 1000000,
                });

                await loader.present();

                this.$http
                    .get('/contacts/' + this.$route.params.id)
                    .then(({data}) => this.contact = data)
                    .catch(error => window.console.error(error))
                    .finally(() => {
                        loader.dismiss();
                    });
            },
            retrieveCommunications() {
                this.$http
                    .post(`/contacts/${this.$route.params.id}/communication`)
                    .then(({data}) => {
                        if (!data || !data.success) {
                            new ApiError(data);
                            return;
                        }

                        this.communications = data.messages;
                    })
                    .catch(error => new ApiError(error));
            },
        },
        created() {
            this.retrieveContact();
            this.retrieveCommunications();
        }
    }
</script>
